import CollectionsDialog from './CollectionsDialog';

export default CollectionsDialog;



// WEBPACK FOOTER //
// ./src/components/Building/Main/CollectionsDialog/index.js